import { FC } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "../../../../../hooks/useTranslate";

import { DashboardSwitch } from "@/dashboard-design-system/Switch";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

export type GeneralPermissionsListProps = {
  permissions: {
    contacts: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
    bank: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
    userManagement: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
    tapToPay: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
  };
  disabled?: boolean;
};

export const GeneralPermissionsList: FC<GeneralPermissionsListProps> = ({ permissions, disabled }) => {
  const { t } = useTranslate();

  return (
    <Stack direction="column" spacing={1}>
      <DashboardTypography variant="subtitle2" vibe="text-neutral-quiet">
        {t("dashboard", "userPermissionModal.generalPermissions")?.toUpperCase()}
      </DashboardTypography>

      <Stack direction="column" spacing={1.5}>
        <DashboardSwitch
          data-test="switch-general-permissions-contacts"
          label={t("dashboard", "userPermissionModal.generalPermissions.contacts")}
          checked={permissions.contacts.checked}
          onChange={(event) => permissions.contacts.onChange(event.target.checked)}
          disabled={disabled}
        />
        <DashboardSwitch
          data-test="switch-general-permissions-bank"
          label={t("dashboard", "userPermissionModal.generalPermissions.bank")}
          checked={permissions.bank.checked}
          onChange={(event) => permissions.bank.onChange(event.target.checked)}
          disabled={disabled}
        />
        <DashboardSwitch
          data-test="switch-general-permissions-user-management"
          label={t("dashboard", "userPermissionModal.generalPermissions.userManagement")}
          checked={permissions.userManagement.checked}
          onChange={(event) => permissions.userManagement.onChange(event.target.checked)}
          disabled={disabled}
        />
        <DashboardSwitch
          data-test="switch-general-permissions-tap-to-pay"
          label={t("dashboard", "userPermissionModal.generalPermissions.tapToPay")}
          checked={permissions.tapToPay.checked}
          onChange={(event) => permissions.tapToPay.onChange(event.target.checked)}
          disabled={disabled}
        />
      </Stack>
    </Stack>
  );
};
